import {type Type} from '@packages/systems/wfdl';
import {qualify} from '@packages/systems/wfdl-Qualified';
const pluginNames = {
  RichTextChildren: 'Basic',
  AutoOrNumber: 'Basic',
  AltText: 'Basic',
  Link: 'Basic',
  LinkModePage: 'Basic',
  LinkModeSection: 'Basic',
  LinkPhoneNote: 'Basic',
  Image: 'Asset',
  Asset: 'Asset',
  Video: 'Embed',
  LottiePath: 'Animation',
  AnimationDuration: 'Animation',
  AnimationLoop: 'Animation',
  AnimationPlayInReverse: 'Animation',
  MultiTextEdit: 'Commerce',
  LockedDynSource: 'Commerce',
  ElementToggle: 'Commerce',
  DismissibleNote: 'Commerce',
} as const;

// FIXME: We treat `name` as `any` here but it _should_ be `TypeName`, right?
// @ts-expect-error - TS7006 - Parameter 'name' implicitly has an 'any' type.
const qualifyName = (name) =>
  // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly RichTextChildren: "Basic"; readonly AutoOrNumber: "Basic"; readonly AltText: "Basic"; readonly Link: "Basic"; readonly LinkModePage: "Basic"; readonly LinkModeSection: "Basic"; ... 11 more ...; readonly DismissibleNote: "Commerce"; }'.
  qualify(pluginNames[name], name);

export const migratePluginDataType = (dataTypeJson: any) => {
  if (dataTypeJson && dataTypeJson.type === 'Plugin') {
    const newDataType: Type = {
      type: 'TypeConstructor',
      val: qualifyName(dataTypeJson.name),
    };

    if (dataTypeJson.system) newDataType.system = dataTypeJson.system;
    if (dataTypeJson.meta) newDataType.meta = dataTypeJson.meta;

    return newDataType;
  }

  return dataTypeJson;
};

export const migrateLiteral = (exprJson: any) => {
  if (
    exprJson &&
    exprJson.type === 'Literal' &&
    exprJson.val &&
    typeof exprJson.val.name === 'string'
  ) {
    return {
      type: 'Literal',
      val: {
        name: qualifyName(exprJson.val.name),
        value: exprJson.val.value,
      },
    };
  }
  return exprJson;
};
